import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import RessourcenPlanungRow from '#components/m/Ressourcenplanung/RessourcenPlanungRow'

export function RessourcenPlanungGrid({ressourcenPlan}) {
  const rows = ressourcenPlan.ressourcenOfAbteilung.map(r => (
    <RessourcenPlanungRow key={r.id} ressourcenOfAbteilung={r} />
  ))
  const monthLabels = []
  for (let i = 0; i < 12; i++) {
    monthLabels.push(
      <div className="ressourcenPlanungGridItemHeader" key={i}>
        {i18n.t(`ressourcenplanung_month_${i}`)}
      </div>,
    )
  }
  return (
    <div className="ressourcenPlanungGrid">
      <div className="ressourcenPlanungHeader">
        <div />
        {monthLabels}
      </div>
      {rows}
    </div>
  )
}

RessourcenPlanungGrid.propTypes = {
  ressourcenPlan: PropTypes.object,
}

export default RessourcenPlanungGrid
